import ScrollReveal from './ScrollReveal.jsx';
import BrandTextHighlight from './BrandTextHighlight.jsx';
import { clsx } from '../../utils/cn.js';

const ACCENTS = {
  navy: {
    blob: 'rgba(13,43,127,0.07)',
    iconWrap: 'bg-[#0d2b7f]/10 ring-[#0d2b7f]/25',
    icon: 'text-[#0d2b7f]',
    line: 'from-[#0d2b7f] via-[#0d2b7f]/70 to-[#1acb12]/80',
  },
  green: {
    blob: 'rgba(26,203,18,0.08)',
    iconWrap: 'bg-[#1acb12]/12 ring-[#1acb12]/30',
    icon: 'text-[#00A63E]',
    line: 'from-[#1acb12] via-[#00A63E]/80 to-[#0d2b7f]/60',
  },
};

/**
 * Sección de texto institucional con animación escalonada (Nosotros).
 */
export default function AboutProseSection({
  title,
  paragraphs,
  icon: Icon,
  variant = 'navy',
  className,
}) {
  const accent = ACCENTS[variant] ?? ACCENTS.navy;

  return (
    <section className={clsx('relative overflow-hidden border-b border-slate-200 py-16 lg:py-20', className)}>
      <div
        className="pointer-events-none absolute -right-20 top-1/2 h-72 w-72 -translate-y-1/2 rounded-full blur-3xl"
        style={{ backgroundColor: accent.blob }}
        aria-hidden
      />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:gap-14">
          <div className="flex shrink-0 flex-col gap-4 lg:w-72">
            <ScrollReveal from="left" scale delayMs={0}>
              <span
                className={clsx(
                  'inline-flex h-14 w-14 items-center justify-center rounded-2xl ring-1 transition-shadow duration-500',
                  accent.iconWrap,
                  'hover:shadow-[0_8px_24px_rgba(0,0,0,0.08)]'
                )}
              >
                <Icon className={clsx('h-7 w-7', accent.icon)} strokeWidth={1.75} aria-hidden />
              </span>
            </ScrollReveal>

            <ScrollReveal from="left" delayMs={120}>
              <h2 className="font-display text-2xl font-bold text-accent-blue md:text-3xl">{title}</h2>
            </ScrollReveal>

            <ScrollReveal from="none" delayMs={240} className="hidden lg:block">
              <div
                className={clsx('h-1 w-16 rounded-full bg-gradient-to-r', accent.line)}
                aria-hidden
              />
            </ScrollReveal>
          </div>

          <div className="max-w-3xl space-y-5 lg:flex-1 lg:pt-1">
            {paragraphs.map((p, i) => (
              <ScrollReveal key={p.slice(0, 48)} from="right" delayMs={180 + i * 110}>
                <p className="text-base leading-relaxed text-slate-600 md:text-[1.05rem] md:leading-[1.75]">
                  <BrandTextHighlight text={p} />
                </p>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
